import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "visitor" }
const _hoisted_2 = { class: "search" }
const _hoisted_3 = { class: "info" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Visitor Profile ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Card Expired ")
const _hoisted_6 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_code_scanner = _resolveComponent("code-scanner")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_visitor_profile = _resolveComponent("visitor-profile")!
  const _component_visiting_companies = _resolveComponent("visiting-companies")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_card, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_code_scanner, {
              "code-type": 'rfid',
              model: _ctx.scanModel,
              preview: false
            }, null, 8, ["model"])
          ]),
          (!_ctx.show)
            ? (_openBlock(), _createBlock(_component_el_empty, {
                key: 0,
                image: "/img/svg/scan.svg",
                description: _ctx.trans('message.visitor_no-matched')
              }, null, 8, ["description"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", {
      class: _normalizeClass([
         'visitor',
         'visitor-validation',
         'grid--vertical',
         { visible: _ctx.show }
       ])
    }, [
      _createVNode(_component_el_form, {
        "label-position": "top",
        size: "small",
        model: _ctx.model,
        disabled: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_card, null, {
              header: _withCtx(() => [
                _hoisted_4,
                (_ctx.expired)
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 0,
                      type: "danger",
                      effect: "dark"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_visitor_profile, { model: _ctx.model }, null, 8, ["model"])
              ]),
              _: 1
            }),
            _createVNode(_component_visiting_companies, {
              ref: "visitingCompanies",
              records: _ctx.visitCompanies
            }, null, 8, ["records"])
          ]),
          _createVNode(_component_el_card, {
            class: "entry-records",
            header: _ctx.trans('label.entry-records')
          }, {
            default: _withCtx(() => [
              (_ctx.entryRecords.length > 0)
                ? (_openBlock(), _createElementBlock("table", _hoisted_6, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", null, _toDisplayString(_ctx.trans('label.entry-time')), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.trans('label.zone')), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.trans('label.event')), 1)
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entryRecords, (entryRecord) => {
                        return (_openBlock(), _createElementBlock("tr", null, [
                          _createElementVNode("td", null, [
                            _createVNode(_component_el_input, {
                              modelValue: entryRecord.eventTime,
                              "onUpdate:modelValue": ($event: any) => ((entryRecord.eventTime) = $event)
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _createElementVNode("td", null, [
                            _createVNode(_component_el_input, {
                              modelValue: entryRecord.zoneName,
                              "onUpdate:modelValue": ($event: any) => ((entryRecord.zoneName) = $event)
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _createElementVNode("td", null, [
                            _createVNode(_component_el_input, {
                              modelValue: entryRecord.IO,
                              "onUpdate:modelValue": ($event: any) => ((entryRecord.IO) = $event)
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ])
                        ]))
                      }), 256))
                    ])
                  ]))
                : (_openBlock(), _createBlock(_component_el_empty, {
                    key: 1,
                    description: "No entry records found."
                  }))
            ]),
            _: 1
          }, 8, ["header"])
        ]),
        _: 1
      }, 8, ["model"])
    ], 2)
  ], 64))
}